export class OrderedChoiceInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
}
